import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';
import { trackSignupIntent, trackDemoRequest, buildSignupURL } from '@/utils/analytics';

const LOGIN_URL = 'https://my.tdfxcapital.net/portal/login';
const SIGNUP_URL = 'https://my.tdfxcapital.net/portal';

export const HeroSection = () => {
  const handleSignup = () => {
    trackSignupIntent('hero_cta', 'website');
    const url = buildSignupURL(SIGNUP_URL, 'hero_live_account');
    window.open(url, '_blank');
  };

  const handleDemo = () => {
    trackDemoRequest('hero_demo_button');
    const url = buildSignupURL(SIGNUP_URL, 'hero_demo', { demo: 'true' });
    window.open(url, '_blank');
  };

  return (
    <section id="home" className="pt-12 pb-16 md:pt-16 md:pb-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          {/* SEO-optimized H1 */}
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-gray-900 mb-6 tracking-tight">
            Professional Forex
            <span className="block text-primary mt-2">Trading Platform</span>
          </h1>
          <p className="text-xl md:text-2xl text-gray-600 mb-10 max-w-3xl mx-auto font-light">
            Trade Forex, Crypto, Indices & Commodities with ultra-low spreads from 0.0 pips and leverage up to 1:500.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
            <Button
              size="lg"
              className="btn-premium text-white font-semibold text-base px-10 h-14"
              onClick={handleSignup}
              data-testid="hero-signup-btn"
            >
              Open Live Account
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
            <Button
              size="lg"
              variant="outline"
              className="text-base px-10 h-14 border-2 font-semibold bg-white text-gray-900 hover:bg-gray-100"
              onClick={handleDemo}
              data-testid="hero-demo-btn"
            >
              Try Free Demo
            </Button>
          </div>

          {/* Trust signals for conversion */}
          <div className="flex flex-wrap items-center justify-center gap-8 text-sm text-gray-600">
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 bg-green-500 rounded-full"></div>
              <span className="font-medium">Licensed in Saint Lucia</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 bg-green-500 rounded-full"></div>
              <span className="font-medium">24/7 Support</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 bg-green-500 rounded-full"></div>
              <span className="font-medium">No Hidden Fees</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;